<template>
  <teleport to="body" >
    <div class="footer-contact-container px-10  py-2 flex justify-between items-center rounded-3xl mb-2 mx-2"
      v-if="withContact">

      <div class="flex items-center gap-2" >
        {{ content.haveQuestion }}
        <span style="font-weight: 700" class="footer-contact-subtitle">
          {{ content.reachOut }}</span>
      </div>
      <router-link to="/contact">
        <button class="learn-more-btn rounded-full my-auto">
          <div class="flex items-center uppercase">
           <span  style="transform: translateX(10px);">{{ content.contactUs }}</span> 
            <img src="/static/images/arrow.svg" style="transform: translateX(30px);" class="w-8 ml-2" />
          </div>
        </button>
      </router-link>

    </div>

    <footer style="background-color: oklch(27.8% 0.033 256.848);color:white"
      class="flex items-center flex-col md:flex-row py-3   gap-5 rounded-t-3xl justify-between px-5"
      >
      <div class="text-lg"> Copyright {{ new Date().getFullYear() }} - Bomo Industrial Co.</div>
      <div >
        <div>Developed by <a href="https://blackace.tech/" target="_blank"> BlackAce</a> </div>
       
      </div>
    </footer>


  </teleport>
</template>

<script>
export default {

  props: ["withContact"],
  inject: ["content"],

};
</script>

<style scoped></style>